module.exports = __webpack_public_path__ + "static/img/icon-kdb.98a99ca2.png";